import script from "./WithdrawPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawPreview.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawPreview.vue?vue&type=style&index=0&id=554b2482&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554b2482"]])

export default __exports__